// Loading.js
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { LeftSide } from '../../components/LeftSide/LeftSide';
import { Navi } from '../../components/Navi/Navi';
import { RightBar } from '../../components/RightBar/RightBar';

const DashBoard = ({ title = 'Dashboard' }) => {
    return (
        <>
            {/* <!-- Begin page --> */}
            <div id="wrapper">
                <Navi title={title} />

                <LeftSide />

                <div className="content-page">
                    <div className="content">
                        {/* <!-- Start Content--> */}
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-xl-3 col-md-6">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="dropdown float-end">
                                                <Link
                                                    to="#"
                                                    className="dropdown-toggle arrow-none card-drop"
                                                    data-bs-toggle="dropdown"
                                                    aria-expanded="false"
                                                >
                                                    <i className="mdi mdi-dots-vertical"></i>
                                                </Link>
                                                <div className="dropdown-menu dropdown-menu-end">
                                                    {/* <!-- item--> */}
                                                    <Link className="dropdown-item">Action</Link>
                                                    {/* <!-- item--> */}
                                                    <Link className="dropdown-item">
                                                        Another action
                                                    </Link>
                                                    {/* <!-- item--> */}
                                                    <Link className="dropdown-item">
                                                        Something else
                                                    </Link>
                                                    {/* <!-- item--> */}
                                                    <Link className="dropdown-item">
                                                        Separated link
                                                    </Link>
                                                </div>
                                            </div>

                                            <h4 className="header-title mt-0 mb-4">
                                                Total Revenue
                                            </h4>

                                            <div className="widget-chart-1">
                                                <div
                                                    className="widget-chart-box-1 float-start"
                                                    dir="ltr"
                                                >
                                                    <input
                                                        data-plugin="knob"
                                                        data-width="70"
                                                        data-height="70"
                                                        data-fgColor="#f05050 "
                                                        data-bgColor="#F9B9B9"
                                                        value="58"
                                                        data-skin="tron"
                                                        data-angleOffset="180"
                                                        data-readOnly={true}
                                                        data-thickness=".15"
                                                    />
                                                </div>

                                                <div className="widget-detail-1 text-end">
                                                    <h2 className="fw-normal pt-2 mb-1"> 256 </h2>
                                                    <p className="text-muted mb-1">Revenue today</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* <!-- end col --> */}

                                <div className="col-xl-3 col-md-6">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="dropdown float-end">
                                                <Link
                                                    to="#"
                                                    className="dropdown-toggle arrow-none card-drop"
                                                    data-bs-toggle="dropdown"
                                                    aria-expanded="false"
                                                >
                                                    <i className="mdi mdi-dots-vertical"></i>
                                                </Link>
                                                <div className="dropdown-menu dropdown-menu-end">
                                                    {/* <!-- item--> */}
                                                    <Link className="dropdown-item">Action</Link>
                                                    {/* <!-- item--> */}
                                                    <Link className="dropdown-item">
                                                        Another action
                                                    </Link>
                                                    {/* <!-- item--> */}
                                                    <Link className="dropdown-item">
                                                        Something else
                                                    </Link>
                                                    {/* <!-- item--> */}
                                                    <Link className="dropdown-item">
                                                        Separated link
                                                    </Link>
                                                </div>
                                            </div>

                                            <h4 className="header-title mt-0 mb-3">
                                                Sales Analytics
                                            </h4>

                                            <div className="widget-box-2">
                                                <div className="widget-detail-2 text-end">
                                                    <span className="badge bg-success rounded-pill float-start mt-3">
                                                        32%{' '}
                                                        <i className="mdi mdi-trending-up"></i>{' '}
                                                    </span>
                                                    <h2 className="fw-normal mb-1"> 8451 </h2>
                                                    <p className="text-muted mb-3">Revenue today</p>
                                                </div>
                                                <div className="progress progress-bar-alt-success progress-sm">
                                                    <div
                                                        className="progress-bar bg-success"
                                                        role="progressbar"
                                                        aria-valuenow="77"
                                                        aria-valuemin="0"
                                                        aria-valuemax="100"
                                                        style={{ width: '77%' }}
                                                    >
                                                        <span className="visually-hidden">
                                                            77% Complete
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* <!-- end col --> */}

                                <div className="col-xl-3 col-md-6">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="dropdown float-end">
                                                <Link
                                                    to="#"
                                                    className="dropdown-toggle arrow-none card-drop"
                                                    data-bs-toggle="dropdown"
                                                    aria-expanded="false"
                                                >
                                                    <i className="mdi mdi-dots-vertical"></i>
                                                </Link>
                                                <div className="dropdown-menu dropdown-menu-end">
                                                    {/* <!-- item--> */}
                                                    <Link className="dropdown-item">Action</Link>
                                                    {/* <!-- item--> */}
                                                    <Link className="dropdown-item">
                                                        Another action
                                                    </Link>
                                                    {/* <!-- item--> */}
                                                    <Link className="dropdown-item">
                                                        Something else
                                                    </Link>
                                                    {/* <!-- item--> */}
                                                    <Link className="dropdown-item">
                                                        Separated link
                                                    </Link>
                                                </div>
                                            </div>

                                            <h4 className="header-title mt-0 mb-4">Statistics</h4>

                                            <div className="widget-chart-1">
                                                <div
                                                    className="widget-chart-box-1 float-start"
                                                    dir="ltr"
                                                >
                                                    <input
                                                        data-plugin="knob"
                                                        data-width="70"
                                                        data-height="70"
                                                        data-fgColor="#ffbd4a"
                                                        data-bgColor="#FFE6BA"
                                                        value="80"
                                                        data-skin="tron"
                                                        data-angleOffset="180"
                                                        data-readOnly={true}
                                                        data-thickness=".15"
                                                    />
                                                </div>
                                                <div className="widget-detail-1 text-end">
                                                    <h2 className="fw-normal pt-2 mb-1"> 4569 </h2>
                                                    <p className="text-muted mb-1">Revenue today</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* <!-- end col --> */}

                                <div className="col-xl-3 col-md-6">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="dropdown float-end">
                                                <Link
                                                    to="#"
                                                    className="dropdown-toggle arrow-none card-drop"
                                                    data-bs-toggle="dropdown"
                                                    aria-expanded="false"
                                                >
                                                    <i className="mdi mdi-dots-vertical"></i>
                                                </Link>
                                                <div className="dropdown-menu dropdown-menu-end">
                                                    {/* <!-- item--> */}
                                                    <Link className="dropdown-item">Action</Link>
                                                    {/* <!-- item--> */}
                                                    <Link className="dropdown-item">
                                                        Another action
                                                    </Link>
                                                    {/* <!-- item--> */}
                                                    <Link className="dropdown-item">
                                                        Something else
                                                    </Link>
                                                    {/* <!-- item--> */}
                                                    <Link className="dropdown-item">
                                                        Separated link
                                                    </Link>
                                                </div>
                                            </div>

                                            <h4 className="header-title mt-0 mb-3">Daily Sales</h4>

                                            <div className="widget-box-2">
                                                <div className="widget-detail-2 text-end">
                                                    <span className="badge bg-pink rounded-pill float-start mt-3">
                                                        32%{' '}
                                                        <i className="mdi mdi-trending-up"></i>{' '}
                                                    </span>
                                                    <h2 className="fw-normal mb-1"> 158 </h2>
                                                    <p className="text-muted mb-3">Revenue today</p>
                                                </div>
                                                <div className="progress progress-bar-alt-pink progress-sm">
                                                    <div
                                                        className="progress-bar bg-pink"
                                                        role="progressbar"
                                                        aria-valuenow="77"
                                                        aria-valuemin="0"
                                                        aria-valuemax="100"
                                                        style={{ width: '77%' }}
                                                    >
                                                        <span className="visually-hidden">
                                                            77% Complete
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* <!-- end col --> */}
                            </div>
                            {/* <!-- end row --> */}

                            <div className="row">
                                <div className="col-xl-4">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="dropdown float-end">
                                                <Link
                                                    to="#"
                                                    className="dropdown-toggle arrow-none card-drop"
                                                    data-bs-toggle="dropdown"
                                                    aria-expanded="false"
                                                >
                                                    <i className="mdi mdi-dots-vertical"></i>
                                                </Link>
                                                <div className="dropdown-menu dropdown-menu-end">
                                                    {/* <!-- item--> */}
                                                    <Link className="dropdown-item">Action</Link>
                                                    {/* <!-- item--> */}
                                                    <Link className="dropdown-item">
                                                        Another action
                                                    </Link>
                                                    {/* <!-- item--> */}
                                                    <Link className="dropdown-item">
                                                        Something else
                                                    </Link>
                                                    {/* <!-- item--> */}
                                                    <Link className="dropdown-item">
                                                        Separated link
                                                    </Link>
                                                </div>
                                            </div>

                                            <h4 className="header-title mt-0">Daily Sales</h4>

                                            <div className="widget-chart text-center">
                                                <div
                                                    id="morris-donut-example"
                                                    dir="ltr"
                                                    style={{ height: '245px' }}
                                                    className="morris-chart"
                                                ></div>
                                                <ul className="list-inline chart-detail-list mb-0">
                                                    <li className="list-inline-item">
                                                        <h5 style={{ color: '#ff8acc' }}>
                                                            <i className="fa fa-circle me-1"></i>
                                                            Series A
                                                        </h5>
                                                    </li>
                                                    <li className="list-inline-item">
                                                        <h5 style={{ color: '#5b69bc' }}>
                                                            <i className="fa fa-circle me-1"></i>
                                                            Series B
                                                        </h5>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* <!-- end col --> */}

                                <div className="col-xl-4">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="dropdown float-end">
                                                <Link
                                                    to="#"
                                                    className="dropdown-toggle arrow-none card-drop"
                                                    data-bs-toggle="dropdown"
                                                    aria-expanded="false"
                                                >
                                                    <i className="mdi mdi-dots-vertical"></i>
                                                </Link>
                                                <div className="dropdown-menu dropdown-menu-end">
                                                    {/* <!-- item--> */}
                                                    <Link className="dropdown-item">Action</Link>
                                                    {/* <!-- item--> */}
                                                    <Link className="dropdown-item">
                                                        Another action
                                                    </Link>
                                                    {/* <!-- item--> */}
                                                    <Link className="dropdown-item">
                                                        Something else
                                                    </Link>
                                                    {/* <!-- item--> */}
                                                    <Link className="dropdown-item">
                                                        Separated link
                                                    </Link>
                                                </div>
                                            </div>
                                            <h4 className="header-title mt-0">Statistics</h4>
                                            <div
                                                id="morris-bar-example"
                                                dir="ltr"
                                                style={{ height: '280px' }}
                                                className="morris-chart"
                                            ></div>
                                        </div>
                                    </div>
                                </div>
                                {/* <!-- end col --> */}

                                <div className="col-xl-4">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="dropdown float-end">
                                                <Link
                                                    to="#"
                                                    className="dropdown-toggle arrow-none card-drop"
                                                    data-bs-toggle="dropdown"
                                                    aria-expanded="false"
                                                >
                                                    <i className="mdi mdi-dots-vertical"></i>
                                                </Link>
                                                <div className="dropdown-menu dropdown-menu-end">
                                                    {/* <!-- item--> */}
                                                    <Link className="dropdown-item">Action</Link>
                                                    {/* <!-- item--> */}
                                                    <Link className="dropdown-item">
                                                        Another action
                                                    </Link>
                                                    {/* <!-- item--> */}
                                                    <Link className="dropdown-item">
                                                        Something else
                                                    </Link>
                                                    {/* <!-- item--> */}
                                                    <Link className="dropdown-item">
                                                        Separated link
                                                    </Link>
                                                </div>
                                            </div>
                                            <h4 className="header-title mt-0">Total Revenue</h4>
                                            <div
                                                id="morris-line-example"
                                                dir="ltr"
                                                style={{ height: '280px' }}
                                                className="morris-chart"
                                            ></div>
                                        </div>
                                    </div>
                                </div>
                                {/* <!-- end col --> */}
                            </div>
                            {/* <!-- end row --> */}

                            <div className="row">
                                <div className="col-xl-3 col-md-6">
                                    <div className="card">
                                        <div className="card-body widget-user">
                                            <div className="d-flex align-items-center">
                                                <div className="flex-shrink-0 avatar-lg me-3">
                                                    <img
                                                        src="assets/images/users/user-3.jpg"
                                                        className="img-fluid rounded-circle"
                                                        alt="user"
                                                    />
                                                </div>
                                                <div className="flex-grow-1 overflow-hidden">
                                                    <h5 className="mt-0 mb-1">Chadengle</h5>
                                                    <p className="text-muted mb-2 font-13 text-truncate">
                                                        coderthemes@gmail.com
                                                    </p>
                                                    <small className="text-warning">
                                                        <b>Admin</b>
                                                    </small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* <!-- end col --> */}

                                <div className="col-xl-3 col-md-6">
                                    <div className="card">
                                        <div className="card-body widget-user">
                                            <div className="d-flex align-items-center">
                                                <div className="flex-shrink-0 avatar-lg me-3">
                                                    <img
                                                        src="assets/images/users/user-2.jpg"
                                                        className="img-fluid rounded-circle"
                                                        alt="user"
                                                    />
                                                </div>
                                                <div className="flex-grow-1 overflow-hidden">
                                                    <h5 className="mt-0 mb-1"> Michael Zenaty</h5>
                                                    <p className="text-muted mb-2 font-13 text-truncate">
                                                        coderthemes@gmail.com
                                                    </p>
                                                    <small className="text-pink">
                                                        <b>Support Lead</b>
                                                    </small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* <!-- end col --> */}

                                <div className="col-xl-3 col-md-6">
                                    <div className="card">
                                        <div className="card-body widget-user">
                                            <div className="d-flex align-items-center">
                                                <div className="flex-shrink-0 avatar-lg me-3">
                                                    <img
                                                        src="assets/images/users/user-1.jpg"
                                                        className="img-fluid rounded-circle"
                                                        alt="user"
                                                    />
                                                </div>
                                                <div className="flex-grow-1 overflow-hidden">
                                                    <h5 className="mt-0 mb-1">Stillnotdavid</h5>
                                                    <p className="text-muted mb-2 font-13 text-truncate">
                                                        coderthemes@gmail.com
                                                    </p>
                                                    <small className="text-success">
                                                        <b>Designer</b>
                                                    </small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* <!-- end col --> */}

                                <div className="col-xl-3 col-md-6">
                                    <div className="card">
                                        <div className="card-body widget-user">
                                            <div className="d-flex align-items-center">
                                                <div className="flex-shrink-0 avatar-lg me-3">
                                                    <img
                                                        src="assets/images/users/user-10.jpg"
                                                        className="img-fluid rounded-circle"
                                                        alt="user"
                                                    />
                                                </div>
                                                <div className="flex-grow-1 overflow-hidden">
                                                    <h5 className="mt-0 mb-1">Tomaslau</h5>
                                                    <p className="text-muted mb-2 font-13 text-truncate">
                                                        coderthemes@gmail.com
                                                    </p>
                                                    <small className="text-info">
                                                        <b>Developer</b>
                                                    </small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* <!-- end col --> */}
                            </div>
                            {/* <!-- end row --> */}

                            <div className="row">
                                <div className="col-xl-4">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="dropdown float-end">
                                                <Link
                                                    to="#"
                                                    className="dropdown-toggle arrow-none card-drop"
                                                    data-bs-toggle="dropdown"
                                                    aria-expanded="false"
                                                >
                                                    <i className="mdi mdi-dots-vertical"></i>
                                                </Link>
                                                <div className="dropdown-menu dropdown-menu-end">
                                                    {/* <!-- item--> */}
                                                    <Link className="dropdown-item">Action</Link>
                                                    {/* <!-- item--> */}
                                                    <Link className="dropdown-item">
                                                        Another action
                                                    </Link>
                                                    {/* <!-- item--> */}
                                                    <Link className="dropdown-item">
                                                        Something else
                                                    </Link>
                                                    {/* <!-- item--> */}
                                                    <Link className="dropdown-item">
                                                        Separated link
                                                    </Link>
                                                </div>
                                            </div>

                                            <h4 className="header-title mb-3">Inbox</h4>

                                            <div className="inbox-widget">
                                                <div className="inbox-item">
                                                    <Link to="#">
                                                        <div className="inbox-item-img">
                                                            <img
                                                                src="assets/images/users/user-1.jpg"
                                                                className="rounded-circle"
                                                                alt=""
                                                            />
                                                        </div>
                                                        <h5 className="inbox-item-author mt-0 mb-1">
                                                            Chadengle
                                                        </h5>
                                                        <p className="inbox-item-text">
                                                            Hey! there I'm available...
                                                        </p>
                                                        <p className="inbox-item-date">13:40 PM</p>
                                                    </Link>
                                                </div>

                                                <div className="inbox-item">
                                                    <Link to="#">
                                                        <div className="inbox-item-img">
                                                            <img
                                                                src="assets/images/users/user-2.jpg"
                                                                className="rounded-circle"
                                                                alt=""
                                                            />
                                                        </div>
                                                        <h5 className="inbox-item-author mt-0 mb-1">
                                                            Tomaslau
                                                        </h5>
                                                        <p className="inbox-item-text">
                                                            I've finished it! See you so...
                                                        </p>
                                                        <p className="inbox-item-date">13:34 PM</p>
                                                    </Link>
                                                </div>

                                                <div className="inbox-item">
                                                    <Link to="#">
                                                        <div className="inbox-item-img">
                                                            <img
                                                                src="assets/images/users/user-3.jpg"
                                                                className="rounded-circle"
                                                                alt=""
                                                            />
                                                        </div>
                                                        <h5 className="inbox-item-author mt-0 mb-1">
                                                            Stillnotdavid
                                                        </h5>
                                                        <p className="inbox-item-text">
                                                            This theme is awesome!
                                                        </p>
                                                        <p className="inbox-item-date">13:17 PM</p>
                                                    </Link>
                                                </div>

                                                <div className="inbox-item">
                                                    <Link to="#">
                                                        <div className="inbox-item-img">
                                                            <img
                                                                src="assets/images/users/user-4.jpg"
                                                                className="rounded-circle"
                                                                alt=""
                                                            />
                                                        </div>
                                                        <h5 className="inbox-item-author mt-0 mb-1">
                                                            Kurafire
                                                        </h5>
                                                        <p className="inbox-item-text">
                                                            Nice to meet you
                                                        </p>
                                                        <p className="inbox-item-date">12:20 PM</p>
                                                    </Link>
                                                </div>

                                                <div className="inbox-item">
                                                    <Link to="#">
                                                        <div className="inbox-item-img">
                                                            <img
                                                                src="assets/images/users/user-5.jpg"
                                                                className="rounded-circle"
                                                                alt=""
                                                            />
                                                        </div>
                                                        <h5 className="inbox-item-author mt-0 mb-1">
                                                            Shahedk
                                                        </h5>
                                                        <p className="inbox-item-text">
                                                            Hey! there I'm available...
                                                        </p>
                                                        <p className="inbox-item-date">10:15 AM</p>
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* <!-- end col --> */}

                                <div className="col-xl-8">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="dropdown float-end">
                                                <Link
                                                    to="#"
                                                    className="dropdown-toggle arrow-none card-drop"
                                                    data-bs-toggle="dropdown"
                                                    aria-expanded="false"
                                                >
                                                    <i className="mdi mdi-dots-vertical"></i>
                                                </Link>
                                                <div className="dropdown-menu dropdown-menu-end">
                                                    {/* <!-- item--> */}
                                                    <Link className="dropdown-item">Action</Link>
                                                    {/* <!-- item--> */}
                                                    <Link className="dropdown-item">
                                                        Another action
                                                    </Link>
                                                    {/* <!-- item--> */}
                                                    <Link className="dropdown-item">
                                                        Something else
                                                    </Link>
                                                    {/* <!-- item--> */}
                                                    <Link className="dropdown-item">
                                                        Separated link
                                                    </Link>
                                                </div>
                                            </div>

                                            <h4 className="header-title mt-0 mb-3">
                                                Latest Projects
                                            </h4>

                                            <div className="table-responsive">
                                                <table className="table table-hover mb-0">
                                                    <thead>
                                                        <tr>
                                                            <th>#</th>
                                                            <th>Project Name</th>
                                                            <th>Start Date</th>
                                                            <th>Due Date</th>
                                                            <th>Status</th>
                                                            <th>Assign</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td>1</td>
                                                            <td>Adminto Admin v1</td>
                                                            <td>01/01/2017</td>
                                                            <td>26/04/2017</td>
                                                            <td>
                                                                <span className="badge bg-danger">
                                                                    Released
                                                                </span>
                                                            </td>
                                                            <td>Coderthemes</td>
                                                        </tr>
                                                        <tr>
                                                            <td>2</td>
                                                            <td>Adminto Frontend v1</td>
                                                            <td>01/01/2017</td>
                                                            <td>26/04/2017</td>
                                                            <td>
                                                                <span className="badge bg-success">
                                                                    Released
                                                                </span>
                                                            </td>
                                                            <td>Adminto admin</td>
                                                        </tr>
                                                        <tr>
                                                            <td>3</td>
                                                            <td>Adminto Admin v1.1</td>
                                                            <td>01/05/2017</td>
                                                            <td>10/05/2017</td>
                                                            <td>
                                                                <span className="badge bg-pink">
                                                                    Pending
                                                                </span>
                                                            </td>
                                                            <td>Coderthemes</td>
                                                        </tr>
                                                        <tr>
                                                            <td>4</td>
                                                            <td>Adminto Frontend v1.1</td>
                                                            <td>01/01/2017</td>
                                                            <td>31/05/2017</td>
                                                            <td>
                                                                <span className="badge bg-purple">
                                                                    Work in Progress
                                                                </span>
                                                            </td>
                                                            <td>Adminto admin</td>
                                                        </tr>
                                                        <tr>
                                                            <td>5</td>
                                                            <td>Adminto Admin v1.3</td>
                                                            <td>01/01/2017</td>
                                                            <td>31/05/2017</td>
                                                            <td>
                                                                <span className="badge bg-warning">
                                                                    Coming soon
                                                                </span>
                                                            </td>
                                                            <td>Coderthemes</td>
                                                        </tr>

                                                        <tr>
                                                            <td>6</td>
                                                            <td>Adminto Admin v1.3</td>
                                                            <td>01/01/2017</td>
                                                            <td>31/05/2017</td>
                                                            <td>
                                                                <span className="badge bg-primary">
                                                                    Coming soon
                                                                </span>
                                                            </td>
                                                            <td>Adminto admin</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* <!-- end col --> */}
                            </div>
                            {/* <!-- end row --> */}
                        </div>
                        {/* <!-- container-fluid --> */}
                    </div>
                    {/* <!-- content --> */}

                    {/* <!-- Footer Start --> */}
                    <footer className="footer">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-md-6">
                                    <script>document.write(new Date().getFullYear())</script> &copy;
                                    Adminto theme by <Link to="">Coderthemes</Link>
                                </div>
                                <div className="col-md-6">
                                    <div className="text-md-end footer-links d-none d-sm-block">
                                        <Link>About Us</Link>
                                        <Link>Help</Link>
                                        <Link>Contact Us</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </footer>
                    {/* <!-- end Footer --> */}
                </div>
            </div>

            <RightBar />

            <div className="rightbar-overlay"></div>
        </>
    );
};

export { DashBoard };
